import { useState } from "react";
import { ApiError } from "../lib/api";
import { Modal } from "./Modal";
import { Button } from "./Button";

export function NewFolderButton({
  onCreate,
  className = "",
}: {
  onCreate: (name: string, parentId: string | null) => Promise<void>;
  className?: string;
}) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    setBusy(true);
    setError(null);
    try {
      await onCreate(name.trim(), null);
      setOpen(false);
      setName("");
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Could not create folder.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Button variant="secondary" size="sm" className={className} onClick={() => setOpen(true)}>
        <svg className="h-4 w-4 flex-shrink-0 text-zinc-400" viewBox="0 0 20 20" fill="currentColor">
          <path d="M2 5a2 2 0 0 1 2-2h3l2 2h7a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm9 3V6.5h-1.5V8H8v1.5h1.5V11H11V9.5h1.5V8H11Z" />
        </svg>
        <span className="whitespace-nowrap">New folder</span>
      </Button>
      <Modal
        open={open}
        onClose={busy ? () => {} : () => setOpen(false)}
        title="New folder"
        size="sm"
        footer={
          <>
            <Button variant="ghost" onClick={() => setOpen(false)} disabled={busy}>
              Cancel
            </Button>
            <Button variant="primary" loading={busy} disabled={!name.trim()} onClick={submit}>
              Create
            </Button>
          </>
        }
      >
        <input
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && name.trim() && submit()}
          placeholder="products"
          className="field"
        />
        {error && (
          <p className="mt-2 rounded-lg border border-red-200 bg-red-50/80 px-3 py-2 text-[13px] text-red-700">{error}</p>
        )}
      </Modal>
    </>
  );
}
